import { MergedRate, Rate } from '~/services/AccommodationService';

const buildMergedRateKey = (roomId: string, winningRateId: string) => `${roomId}-${winningRateId}`;

export const getMergedRateKeyForWinningRate = (rate: Pick<Rate, 'roomId' | 'id'>) => {
  return buildMergedRateKey(rate.roomId, rate.id);
};

export const getMergedRateKeyForMergedRate = (rate: Pick<MergedRate, 'roomId' | 'winningRateId'>) => {
  return buildMergedRateKey(rate.roomId, rate.winningRateId);
};

export const groupMergedRatesByWinner = (mergedRates: Array<MergedRate>) => {
  return mergedRates.reduce<Record<string, Array<MergedRate>>>((acc, rate) => {
    const key = getMergedRateKeyForMergedRate(rate);
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(rate);
    return acc;
  }, {});
};
